import React, { useState } from "react";
import Box from "@mui/material/Box";
import AppTabs from "../Common/Tabs/AppTabs";
import ResponsiveContentWrapper from "../layout/ResponsiveContentWrapper";
import AssetUploadForm from "./AssetUploadForm";
import AssetViewForm from "./AssetViewForm";
import AssetDeleteForm from "./AssetDeleteForm";

const ASSET_TABS = [
  { label: "Create Asset" },
  { label: "Update Asset" },
  { label: "View Asset" },
  { label: "Delete Asset" },
];

const AssetManagement = ({ wrapperClass }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <ResponsiveContentWrapper className={wrapperClass || ""}>
      <Box sx={{ width: "100%", minWidth: 0 }}>
        <AppTabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          tabs={ASSET_TABS}
          variant="scrollable"
          scrollButtons="auto"
          tabMinWidth="auto"
          appearance="neutral"
        />
        <Box sx={{ mt: 2 }}>
          {activeTab === 0 && <AssetUploadForm mode="create" />}
          {activeTab === 1 && <AssetUploadForm mode="update" />}
          {activeTab === 2 && <AssetViewForm />}
          {activeTab === 3 && <AssetDeleteForm />}
        </Box>
      </Box>
    </ResponsiveContentWrapper>
  );
};

export default AssetManagement;
